import { render, staticRenderFns } from "./monthly-add-or-update.vue?vue&type=template&id=fa9f2176&scoped=true&"
import script from "./monthly-add-or-update.vue?vue&type=script&lang=js&"
export * from "./monthly-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./monthly-add-or-update.vue?vue&type=style&index=0&id=fa9f2176&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9f2176",
  null
  
)

export default component.exports